module.exports = __webpack_public_path__ + "img/barva-grey.647b241.webp";